module.exports = __webpack_public_path__ + "static/media/11(2).72be61dc.jpg";